import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import moment from "moment";

export const findAllDull = createAsyncThunk(
  "Dull/FindAllDullIssue",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/FindAllDullIssue`,
        formData
      );

      return response.data.Data;
    } catch (error: any) {
      console.error("Error Fetching Dull", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createDull = createAsyncThunk(
  "Dull/InsertDullIssue",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/InsertDullIssue`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Create Dull:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDull = createAsyncThunk(
  "Dull/UpdateDullIssue",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/UpdateDullIssue`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Dull:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDull = createAsyncThunk(
  "Dull/DeleteDullIssue",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/DeleteDullIssue`,
        { dull_issue_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Deleting Ghat:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getDullById = createAsyncThunk(
  "Dull/FindByIDDullIssue",
  async (ID: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/FindByIDDullIssue`,
        { dull_issue_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        id: result.id,
        dull_issue_guid: result.dull_issue_guid,
        dull_issue_no: result.dull_issue_no,
        issue_date: result.issue_date ? moment(result.issue_date).toDate() : "",
        approx_delivery_date: result.approx_delivery_date
          ? moment(result.approx_delivery_date).toDate()
          : "",
        karigar_id: result.karigar_id,
        karigar_name: result.karigar_name,
        address: result.address,
        karigar_nick_name: result.karigar_nick_name,
        karigarIdWiseOutStandingAmount: result?.karigarIdWiseOutStandingAmount,
        dull_issue_order: result?.dull_issue_order,
      } as any;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Dull:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteDullOrderItems = createAsyncThunk(
  "Dull/DeleteDullIssueOrder",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/DeleteDullIssueOrder`,
        { id: ID }
      );
      SuccessToast(response?.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Dull Order item:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateDullImage = createAsyncThunk(
  "Dull/DullIssueImageUpdate",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Dull/DullIssueImageUpdate`,
        formdata
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Update Dull Image:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

